import { useState } from "react";
import { Loader2 } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { useMe } from "@/context/MeContext";

export const emptyOffer = { name: "", description: "", category: "", image_url: "", stock: 0, price_bronze: "", price_gold: "", price_diamond: "" };

export function OfferForm({ initial = emptyOffer, onSubmit, submitLabel = "Invia per approvazione" }) {
  const { config } = useMe();
  const [f, setF] = useState(initial);
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const b = parseFloat(f.price_bronze), g = parseFloat(f.price_gold), d = parseFloat(f.price_diamond);
  const invalid = b > 0 && g > 0 && d > 0 && !(b >= g && g >= d);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await onSubmit({ ...f, stock: parseInt(f.stock || 0, 10), price_bronze: b, price_gold: g, price_diamond: d });
    } finally {
      setBusy(false);
    }
  };

  return (
    <form onSubmit={submit} className="grid gap-4 sm:grid-cols-2" data-testid="offer-form">
      <div className="sm:col-span-2"><Label className="text-xs text-slate-400">Nome offerta</Label><Input data-testid="offer-name" value={f.name} onChange={set("name")} className="mt-1 bg-[#1C1F2C]" /></div>
      <div className="sm:col-span-2"><Label className="text-xs text-slate-400">Descrizione</Label><Textarea data-testid="offer-description" value={f.description} onChange={set("description")} className="mt-1 bg-[#1C1F2C]" rows={4} /></div>
      <div>
        <Label className="text-xs text-slate-400">Categoria</Label>
        <Select value={f.category} onValueChange={(v) => setF({ ...f, category: v })}>
          <SelectTrigger data-testid="offer-category" className="mt-1 bg-[#1C1F2C]"><SelectValue placeholder="Scegli…" /></SelectTrigger>
          <SelectContent>{(config?.categories || []).map((c) => <SelectItem key={c} value={c}>{c}</SelectItem>)}</SelectContent>
        </Select>
      </div>
      <div><Label className="text-xs text-slate-400">Stock</Label><Input data-testid="offer-stock" type="number" min="0" value={f.stock} onChange={set("stock")} className="mt-1 bg-[#1C1F2C]" /></div>
      <div className="sm:col-span-2"><Label className="text-xs text-slate-400">URL immagine</Label><Input data-testid="offer-image" value={f.image_url} onChange={set("image_url")} placeholder="https://…" className="mt-1 bg-[#1C1F2C]" /></div>
      {[["price_bronze", "Prezzo Bronze (€)", "#CD7F32"], ["price_gold", "Prezzo Gold (€)", "#F59E0B"], ["price_diamond", "Prezzo Diamond (€)", "#38BDF8"]].map(([k, l, c]) => (
        <div key={k}><Label className="text-xs" style={{ color: c }}>{l}</Label><Input data-testid={`offer-${k}`} type="number" step="0.01" min="0" value={f[k]} onChange={set(k)} className="mt-1 bg-[#1C1F2C]" /></div>
      ))}
      {invalid && <p className="text-sm text-red-400 sm:col-span-2" data-testid="offer-price-error">I prezzi devono rispettare Bronze ≥ Gold ≥ Diamond.</p>}
      <button data-testid="offer-submit" disabled={busy || invalid || !f.name || !f.category} className="flex h-11 items-center justify-center gap-2 rounded-xl bg-amber-500 font-semibold text-black hover:bg-amber-400 disabled:opacity-50 sm:col-span-2">
        {busy && <Loader2 className="h-4 w-4 animate-spin" />} {submitLabel}
      </button>
    </form>
  );
}
